export const TYPES = {
  primaryApi: Symbol.for("primaryApi"),
  store: Symbol.for("store"),
};
